import { Routes } from "@angular/router";

export const routes: Routes = [
    {
        path: "assess/:token",
        loadChildren: () => import("./modules/assessment/assessment.routes").then((m) => m.ASSESSMENT_ROUTES),
    },
    {
        path: "**",
        loadComponent: () =>
            import("./modules/assessment/components/link-error-page/link-error-page.component").then(
                (c) => c.LinkErrorPageComponent,
            ),
        data: { kind: "invalid" },
    },
];
